import { Component, Input } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-table-operation-button',
  templateUrl: './mx.table-operation-button.component.html',
  styleUrls: ['./mx.table-operation-button.component.scss'],
})
export class MxTableOperationButtonComponent extends MxBaseComponent {
  @Input() tooltip: string;
  @Input() icon: string;
  @Input() styleClass: string;
  @Input() type: string = 'rounded';
  @Input() spacing: string = 'mr-2';
  @Input() loading: boolean;
  @Input() disabled: (event?: any) => boolean;
  @Input() command: (event?: any, rawData?: any) => void;
  @Input() rowData: any;
}
